import { endOfMonth } from "date-fns";

const now = new Date();

export const colors = {
    MB_INFO_COLOR_LIGHTEST: "rgba(0, 135, 238, 0.1)",
    MB_INFO_COLOR_LIGHT: "rgba(0, 135, 238, 0.2)",
    MB_INFO_COLOR_MAIN: "rgba(0, 135, 238, 1)",
    MB_SUCCESS_COLOR_LIGHT: "rgba(67, 182, 91, 0.2)",
    MB_SUCCESS_COLOR_MAIN: "rgba(82, 163, 0, 1)",
    MB_SUCCESS_COLOR_DARK: "rgba(21, 115, 0, 1)",
    MB_WARNING_COLOR_MAIN: "rgba(218, 1, 1, 1)",
    MB_WARNING_COLOR_DARK: "rgba(139,0,0,1)",
    MB_HELPERTEXT_COLOR_MAIN: "rgb(167,167,167)",
    MB_INPUT_BORDER_COLOR_MAIN: "rgb(0,0,0,0.23)",
    MB_CAUTION_COLOR_MAIN: "rgba(249, 97, 6, 1)",
    MB_CAUTION_COLOR_LIGHT: "rgba(249, 97, 6, 0.25)",
    MB_BODY_COLOR_MAIN: "#6b6b6b",
    MB_TRANSPARENT_MAIN: "rgba(0,0,0,0)",
    MB_GREY_MEDIUM: "#A7A7A7",
    MB_GREY_LIGHT: "#D9D9D9",
    MB_GREY_LIGHT_OLD: "#DEDEDE",
    MB_GREY_LIGHTEST: "#F4F4F4",
    MB_DISABLED_MAIN: "#C4C4C4",
    MB_MAP_WAITLIST_PIN: "#F96106"
};
export const currencies = [
    {
        value: "CAD",
        label: "Canadian Dollar (CAD)"
    },
    {
        value: "USD",
        label: "US Dollar (USD)"
    },
    {
        value: "GBP",
        label: "British Pound sterling (GBP)"
    },
    {
        value: "AUD",
        label: "Australian Dollar (AUD)"
    },
    {
        value: "BBD",
        label: "Barbados Dollar (BBD)"
    },
    {
        value: "JMD",
        label: "Jamaican Dollar (JMD)"
    }
];

export const COUNTRY_CURRENCY_MAP = {
    ca: "CAD",
    us: "USD",
    gb: "GBP",
    au: "AUD",
    can: "CAD",
    usa: "USD",
    aus: "AUD",
    gbr: "GBP"
};
export const DEFAULT_CURRENCY = "USD";

export const getCurrencyForCountry = (countryCode) =>
    COUNTRY_CURRENCY_MAP[countryCode?.toLowerCase()] || DEFAULT_CURRENCY;

export const countryCodes = [
    {
        value: "ca",
        label: "Canada (ca)"
    },
    {
        value: "us",
        label: "United States (us)"
    },
    {
        value: "gb",
        label: "United Kingdom (gb)"
    },
    {
        value: "au",
        label: "Australia (au)"
    },
    {
        value: "bb",
        label: "Barbados (bb)"
    },
    {
        value: "jm",
        label: "Jamaica (jm)"
    }
];

export const subscriptionLevelConst = [
    {
        value: "FREE_TRIAL_BASIC",
        label: "Free Trial"
    },
    {
        value: "SOLE_OPERATOR",
        label: "Sole Operator"
    },
    {
        value: "BASIC",
        label: "Starter"
    },
    {
        value: "PROFESSIONAL",
        label: "Professional"
    },
    {
        value: "ENTERPRISE",
        label: "Enterprise"
    }
];

export const events = [
    {
        id: 0,
        title: "All Day Event very long title",
        allDay: true,
        start: new Date(2019, 11, 4, 0, 0, 0),
        end: new Date(2019, 11, 4, 0, 0, 0)
    },
    {
        id: 1,
        title: "Long Event",
        start: new Date(2015, 3, 7),
        end: new Date(2015, 3, 10)
    },

    {
        id: 2,
        title: "DTS STARTS",
        start: new Date(2016, 2, 13, 0, 0, 0),
        end: new Date(2016, 2, 20, 0, 0, 0)
    },

    {
        id: 3,
        title: "DTS ENDS",
        start: new Date(2016, 10, 6, 0, 0, 0),
        end: new Date(2016, 10, 13, 0, 0, 0)
    },

    {
        id: 4,
        title: "Some Event",
        start: new Date(2015, 3, 9, 0, 0, 0),
        end: new Date(2015, 3, 10, 0, 0, 0)
    },
    {
        id: 5,
        title: "Conference",
        start: new Date(2015, 3, 11),
        end: new Date(2015, 3, 13),
        desc: "Big conference for important people"
    },
    {
        id: 6,
        title: "Meeting",
        start: new Date(2015, 3, 12, 10, 30, 0, 0),
        end: new Date(2015, 3, 12, 12, 30, 0, 0),
        desc: "Pre-meeting meeting, to prepare for the meeting"
    },
    {
        id: 7,
        title: "Lunch",
        start: new Date(2015, 3, 12, 12, 0, 0, 0),
        end: new Date(2015, 3, 12, 13, 0, 0, 0),
        desc: "Power lunch"
    },
    {
        id: 8,
        title: "Meeting",
        start: new Date(2015, 3, 12, 14, 0, 0, 0),
        end: new Date(2015, 3, 12, 15, 0, 0, 0)
    },
    {
        id: 9,
        title: "Happy Hour",
        start: new Date(2015, 3, 12, 17, 0, 0, 0),
        end: new Date(2015, 3, 12, 17, 30, 0, 0),
        desc: "Most important meal of the day"
    },
    {
        id: 10,
        title: "Dinner",
        start: new Date(2015, 3, 12, 20, 0, 0, 0),
        end: new Date(2015, 3, 12, 21, 0, 0, 0)
    },
    {
        id: 11,
        title: "Birthday Party",
        start: new Date(2015, 3, 13, 7, 0, 0),
        end: new Date(2015, 3, 13, 10, 30, 0)
    },
    {
        id: 12,
        title: "Late Night Event",
        start: new Date(2015, 3, 17, 19, 30, 0),
        end: new Date(2015, 3, 18, 2, 0, 0)
    },
    {
        id: 12.5,
        title: "Late Same Night Event",
        start: new Date(2015, 3, 17, 19, 30, 0),
        end: new Date(2015, 3, 17, 23, 30, 0)
    },
    {
        id: 13,
        title: "Multi-day Event",
        start: new Date(2015, 3, 20, 19, 30, 0),
        end: new Date(2015, 3, 22, 2, 0, 0)
    },
    {
        id: 14,
        title: "Today",
        start: new Date(new Date().setHours(new Date().getHours() - 3)),
        end: new Date(new Date().setHours(new Date().getHours() + 3))
    },
    {
        id: 15,
        title: "Point in Time Event",
        start: now,
        end: now
    }
];

export const CustomerColumns = [
    {
        title: "Active",
        name: "user.active",
        align: "center",
        className: ""
    },
    {
        title: "Name & Email Address",
        name: "user.name",
        align: "left",
        className: ""
    },
    {
        title: "Notes",
        name: "client.notes",
        align: "center",
        className: "clientNotesColumn"
    },
    {
        title: "Address",
        name: "user.address",
        align: "left",
        className: ""
    },
    {
        title: "Sales YTD",
        name: "stats.sales_ytd",
        align: "center",
        className: ""
    },
    {
        title: "Login",
        name: "user.registered",
        align: "center",
        className: ""
    }
];

export const CompanyLocationColumns = [
    {
        title: "Location Name",
        name: "locationname",
        align: "left",
        className: ""
    },
    {
        title: "Address",
        name: "addressoneline",
        align: "left",
        className: ""
    },
    {
        title: "Virtual",
        name: "virtual",
        align: "center",
        className: ""
    }
];

export const ProviderLocationColumns = [
    {
        title: "Travel Zone Name",
        name: "name",
        align: "left",
        className: ""
    },
    {
        title: "Address",
        name: "addressoneline",
        align: "left",
        className: ""
    }
];

export const ReviewColumns = [
    {
        title: "Rating",
        name: "ratingstars",
        align: "left",
        className: ""
    },
    {
        title: "Provider Review",
        name: "ratingtext",
        align: "left",
        className: ""
    },
    {
        title: "Date Created",
        name: "createdAt",
        align: "left",
        className: ""
    }
];

export const AdminBookingListColumns = [
    {
        title: "Description",
        name: "desc",
        align: "left",
        className: ""
    },
    {
        title: "Booking Location",
        name: "location",
        align: "left",
        className: ""
    },
    {
        title: "Client Name",
        name: "clientName",
        align: "left",
        className: ""
    },
    {
        title: "Client Phone",
        name: "clientPhone",
        align: "left",
        className: ""
    },
    {
        title: "Provider Name",
        name: "providerName",
        align: "left",
        className: ""
    },
    {
        title: "Start Date",
        name: "startDateDesc",
        align: "left",
        className: ""
    },
    {
        title: "Date Created",
        name: "dateCreated",
        align: "left",
        className: ""
    },
    {
        title: "Status",
        name: "status",
        align: "left",
        className: ""
    },
    {
        title: "Initial Charge",
        name: "initialCharge",
        align: "left",
        className: ""
    },
    {
        title: "Additional Charges",
        name: "additionalCharges",
        align: "left",
        className: ""
    },
    {
        title: "Rating",
        name: "ratingstars",
        align: "center",
        className: ""
    }
];

export const ClientBookingListColumns = [
    {
        title: "Description",
        name: "desc",
        align: "left",
        className: ""
    },
    {
        title: "Booking Location",
        name: "location",
        align: "left",
        className: ""
    },
    {
        title: "Provider Name",
        name: "providerName",
        align: "left",
        className: ""
    },
    {
        title: "Start Date",
        name: "startDateDesc",
        align: "left",
        className: ""
    },
    {
        title: "Date Created",
        name: "dateCreated",
        align: "left",
        className: ""
    },
    {
        title: "Status",
        name: "status",
        align: "left",
        className: ""
    },
    {
        title: "Initial Charge",
        name: "initialCharge",
        align: "left",
        className: ""
    },
    {
        title: "Additional Charges",
        name: "additionalCharges",
        align: "left",
        className: ""
    },
    {
        title: "Rating",
        name: "ratingstars",
        align: "center",
        className: ""
    }
];

export const ProviderBookingListColumnsMobile = [
    {
        title: "Description",
        name: "desc",
        align: "left",
        className: ""
    },
    {
        title: "Booking Location",
        name: "location",
        align: "left",
        className: ""
    },
    {
        title: "Start Date",
        name: "startDateDesc",
        align: "left",
        className: ""
    },
    {
        title: "Status",
        name: "status",
        align: "left",
        className: ""
    },
    {
        title: "Client Name",
        name: "clientName",
        align: "left",
        className: ""
    }
];

export const ProviderBookingListColumnsMobilePending =
    ProviderBookingListColumnsMobile.filter((col) => col.name !== "status");

export const ProviderBookingListColumnsMobileFuture = [
    ...ProviderBookingListColumnsMobile,
    {
        title: "Client Phone",
        name: "clientPhone",
        align: "left",
        className: ""
    }
];

export const ProviderBookingListColumnsDesktop = [
    ...ProviderBookingListColumnsMobile,
    {
        title: "Date Created",
        name: "dateCreated",
        align: "left",
        className: ""
    }
];

export const ProviderBookingListColumnsDesktopFuture = [
    ...ProviderBookingListColumnsMobileFuture,
    {
        title: "Date Created",
        name: "dateCreated",
        align: "left",
        className: ""
    }
];

export const BookingReqListColumns = [
    {
        title: "Booking Type",
        name: "bookingType",
        align: "left",
        className: ""
    },
    {
        title: "Description",
        name: "serviceAndPackage",
        align: "left",
        className: ""
    },
    {
        title: "Location",
        name: "bookingLoc",
        align: "left",
        className: ""
    },
    {
        title: "Provider",
        name: "providerDetails",
        align: "left",
        className: ""
    },
    {
        title: "Client",
        name: "clientDetails",
        align: "left",
        className: ""
    },
    {
        title: "No. of Bookings",
        name: "numberOfBookings",
        align: "left",
        className: ""
    },
    {
        title: "Alternate Providers?",
        name: "tryOtherProviders",
        align: "left",
        className: ""
    },
    {
        title: "Created",
        name: "createdDesc",
        align: "left",
        className: ""
    }
];
export const NonpendingBRListColumns = [
    {
        title: "Status",
        name: "status",
        align: "left",
        className: ""
    },
    {
        title: "Booking Type",
        name: "bookingType",
        align: "left",
        className: ""
    },
    {
        title: "Description",
        name: "serviceAndPackage",
        align: "left",
        className: ""
    },
    {
        title: "Location",
        name: "bookingLoc",
        align: "left",
        className: ""
    },
    {
        title: "Provider",
        name: "providerDetails",
        align: "left",
        className: ""
    },
    {
        title: "Client",
        name: "clientDetails",
        align: "left",
        className: ""
    },
    {
        title: "No. of Bookings",
        name: "numberOfBookings",
        align: "left",
        className: ""
    },
    {
        title: "Final Update",
        name: "createdDesc",
        align: "left",
        className: ""
    }
];

export const ScheduleColumns = [
    {
        title: "Location Name",
        name: "locationName",
        align: "left",
        className: ""
    },
    {
        title: "Service Type",
        name: "serviceName",
        align: "left",
        className: ""
    },
    {
        title: "Date Range",
        name: "dateRange",
        align: "left",
        className: ""
    },
    {
        title: "Repeat",
        name: "repeat",
        align: "left",
        className: ""
    },
    {
        title: "Time Range",
        name: "timeRange",
        align: "left",
        className: ""
    },
    {
        title: "",
        name: "active",
        align: "left",
        className: ""
    }
];

export const TimeBlockColumns = [
    {
        title: "Start Date",
        name: "startDate",
        align: "left",
        className: ""
    },
    {
        title: "End Date",
        name: "endDate",
        align: "left",
        className: ""
    },
    {
        title: "Repeat",
        name: "repeat",
        align: "left",
        className: ""
    },
    {
        title: "Time Range",
        name: "timeRange",
        align: "left",
        className: ""
    }
];

export const orderColumns = [
    {
        title: "Company",
        name: "companyName",
        align: "left",
        className: ""
    },
    {
        title: "Order Date",
        name: "createdAt",
        align: "left",
        className: ""
    },
    {
        title: "Status",
        name: "status",
        align: "left",
        className: ""
    },
    {
        title: "Client",
        name: "clientName",
        align: "left",
        className: ""
    },
    {
        title: "Provider",
        name: "providerName",
        align: "left",
        className: ""
    },
    {
        title: "Credits Left",
        name: "credits",
        align: "left",
        className: ""
    },
    {
        title: "Subtotal",
        name: "subtotal",
        align: "right",
        className: ""
    },
    {
        title: "Service Fee",
        name: "servicechargeamt",
        align: "right",
        className: ""
    },
    {
        title: "Tax",
        name: "taxamt",
        align: "right",
        className: ""
    },
    {
        title: "Total",
        name: "total",
        align: "right",
        className: ""
    },
    {
        title: "Misc. Charges",
        name: "miscChargesString",
        align: "right",
        className: ""
    },
    {
        title: "Additional Charges",
        name: "additionalChargesString",
        align: "right",
        className: ""
    }
];

export const orderColumnsAdmin = [
    {
        title: "Order Date",
        name: "createdAt",
        align: "left",
        className: ""
    },
    {
        title: "Order No.",
        name: "orderNo",
        align: "left",
        className: ""
    },
    {
        title: "Status",
        name: "status",
        align: "left",
        className: ""
    },
    {
        title: "Client",
        name: "clientName",
        align: "left",
        className: ""
    },
    {
        title: "Booking Address",
        name: "addressoneline",
        align: "left",
        className: ""
    },
    {
        title: "Provider",
        name: "providerName",
        align: "left",
        className: ""
    },
    {
        title: "Credits Left",
        name: "credits",
        align: "left",
        className: ""
    },
    {
        title: "Subtotal",
        name: "subtotal",
        align: "right",
        className: ""
    },
    {
        title: "Service Fee",
        name: "servicechargeamt",
        align: "right",
        className: ""
    },
    {
        title: "Tax",
        name: "taxamt",
        align: "right",
        className: ""
    },
    {
        title: "Total",
        name: "total",
        align: "right",
        className: ""
    },
    {
        title: "Misc. Charges",
        name: "miscChargesString",
        align: "right",
        className: ""
    },
    {
        title: "Additional Charges",
        name: "additionalChargesString",
        align: "right",
        className: ""
    }
];

export const AdditionalChargesColumns = [
    {
        title: "Charge Amount",
        name: "amount",
        align: "left",
        className: ""
    },
    {
        title: "Desc",
        name: "desc",
        align: "left",
        className: ""
    },
    {
        title: "Note",
        name: "note",
        align: "left",
        className: ""
    },
    {
        title: "Order No.",
        name: "orderNum",
        align: "left",
        className: ""
    },
    {
        title: "Created By",
        name: "createdBy",
        align: "left",
        className: ""
    },
    {
        title: "Date Created",
        name: "dateString",
        align: "left",
        className: ""
    }
];

export const PotentialSalesColumns = [
    {
        title: "Request Date",
        name: "createdAt",
        align: "left",
        className: ""
    },
    {
        title: "Client Name",
        name: "clientName",
        align: "left",
        className: ""
    },
    {
        title: "Client Phone",
        name: "phone",
        align: "left",
        className: ""
    },
    {
        title: "Email Address",
        name: "emailaddress",
        align: "left",
        className: ""
    },
    {
        title: "Booking Address",
        name: "addressoneline",
        align: "left",
        className: ""
    },
    {
        title: "Requested Services",
        name: "serviceString",
        align: "left",
        className: ""
    },
    {
        title: "Requested Skills",
        name: "skillsString",
        align: "left",
        className: ""
    },
    {
        title: "Requested Time of Day",
        name: "todString",
        align: "left",
        className: ""
    },
    {
        title: "Message",
        name: "",
        align: "left",
        className: ""
    }
];

export const GOOGLE_FONTS = [
    {
        font: "Open Sans"
    },
    {
        font: "Lobster"
    },
    {
        font: "Lato"
    },
    {
        font: "Nunito"
    },
    {
        font: "Ubuntu"
    },
    {
        font: "Merriweather Sans"
    },
    {
        font: "Pacifico"
    },
    {
        font: "Source Sans Pro"
    },
    {
        font: "Work Sans"
    },
    {
        font: "Titillium Web"
    }
];

export const TIME_SUGGESTION_CONFIG_DEFAULTS = {
    isEnabled: true,
    timeOfFirstBookingOfTheDay: "ANY_TIME",
    forceClientAccept: false,
    maxTravelTimeMinutes: 30
};

export const MAX_NUMBER_OF_SUGGESTED_SLOTS_TO_DISPLAY = 10;
export const MAX_NUMBER_OF_SUGGESTED_DAYS_TO_DISPLAY = 10;
export const DEFAULT_NUMBER_OF_LOOKAHEAD_DAYS = 7;
export const EMAIL_REGEX =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const FIRST_AND_LAST_SLOT_OF_BLOCK = "FIRST_AND_LAST_SLOT_OF_BLOCK";
export const ANY_TIME = "ANY_TIME";
export const SPECIFIC_TIME = "SPECIFIC_TIME";
export const emptyDayAnchorTimeMethodOptions = [
    {
        value: ANY_TIME,
        text: "Any time"
    },
    {
        value: FIRST_AND_LAST_SLOT_OF_BLOCK,
        text: "First and last available"
    },
    {
        value: SPECIFIC_TIME,
        text: "Specific time"
    }
];
export const anchorTimeOptions = [
    {
        value: "00:00",
        text: "12:00 AM"
    },
    {
        value: "01:00",
        text: "1:00 AM"
    },
    {
        value: "02:00",
        text: "2:00 AM"
    },
    {
        value: "03:00",
        text: "3:00 AM"
    },
    {
        value: "04:00",
        text: "4:00 AM"
    },
    {
        value: "05:00",
        text: "5:00 AM"
    },
    {
        value: "06:00",
        text: "6:00 AM"
    },
    {
        value: "07:00",
        text: "7:00 AM"
    },
    {
        value: "08:00",
        text: "8:00 AM"
    },
    {
        value: "09:00",
        text: "9:00 AM"
    },
    {
        value: "10:00",
        text: "10:00 AM"
    },
    {
        value: "11:00",
        text: "11:00 AM"
    },
    {
        value: "12:00",
        text: "12:00 PM"
    },
    {
        value: "13:00",
        text: "1:00 PM"
    },
    {
        value: "14:00",
        text: "2:00 PM"
    },
    {
        value: "15:00",
        text: "3:00 PM"
    },
    {
        value: "16:00",
        text: "4:00 PM"
    },
    {
        value: "17:00",
        text: "5:00 PM"
    },
    {
        value: "18:00",
        text: "6:00 PM"
    },
    {
        value: "19:00",
        text: "7:00 PM"
    },
    {
        value: "20:00",
        text: "8:00 PM"
    },
    {
        value: "21:00",
        text: "9:00 PM"
    },
    {
        value: "22:00",
        text: "10:00 PM"
    },
    {
        value: "23:00",
        text: "11:00 PM"
    }
];

export const maxTravelTimeMinutesBetweenBookings = [
    5, 10, 15, 20, 25, 30, 45, 60, 90, 120
];
export const DEFAULT_BUFFER_TIME_MINS = 10;
export const bufferTimeMinutesBetweenBookings = [5, 10, 15, 20, 25, 30];
export const TRAVEL_BUFFER = 10; //minutes
export const FEATURE_NAME_CLUSTERING = "Clustering"; // travel time optimized booking time suggestions
export const IMPERIAL_COUNTRIES = ["USA", "UK"];

export const WEEK_DAYS_ABBREVIATED = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];

export const defaultBrandingStates = {
    primaryColor: "#0087EE",
    logoURL:
        "https://marketbox-prod-booknow.s3.amazonaws.com/public/company-assets/default_logo.png",
    showLogo: true,
    displayNameNextToLogo: true,
    logoAsCircle: false,
    showHeader: true,
    backgroundURL:
        "https://marketbox-prod-booknow.s3.amazonaws.com/public/company-assets/default_background.png",
    backgroundColor: "#0087EE",
    buttonColor: "#0087EE",
    headerTransparency: 0.5,
    showHeaderText: true,
    headerFontType: "Arial",
    headerFontColor: "#000000",
    buttonTextColor: "#FFFFFF",
    companyName: "Put your company name here",
    companyNameFontSize: 60,
    companyTagline: "Describe your what company offers",
    companyTaglineFontSize: 24,
    companyDescription: "Put a call to action or your company slogan",
    companyDescriptionFontSize: 16,
    showHeadingOne: true,
    showHeadingTwo: true,
    showHeadingThree: true
};

export const defaultDomainStates = {
    homepageURL: "",
    subdomain: "",
    subdomainError: false,
    subdomainErrorMessage: "",
    taglineError: false,
    taglineErrorMessage: "",
    tagline: ""
};

export const defaultBookingStates = {
    displayProviderRatings: true,
    clientNotesHeading: "",
    mandatoryNotes: false,
    useAnonymousPermalink: true,
    bookingIncrements: 30,
    noProviderMessage:
        "Thank you for your interest. Please provide your contact info so our team can reach out to nearby providers to see if we can provide service in your area.",
    showProviderAcceptance: true,
    tosURL: "",
    categoryDisplay: "ALLOPEN",
    servicesDisplay: "CARD",
    checkoutOption: "ACCOUNT_OR_GUEST",
    displayServicePrices: true,
    clientMayCreateAccount: true
};

export const defaultBookingFlowSettingsFiles = {
    logoFile: "",
    backgroundFile: "",
    tosFile: ""
};

export const SUBDOMAIN_REGEX_SPECIAL_CHARS = /[^a-z0-9-]/g;
export const SUBDOMAIN_REGEX_MULTIPLE_HYPHENS = /-+/g;
export const AMPLIFY_GRAPHQL_LIMIT = 500;
export const MAX_USERS_ESTIMATE = 3000; //includes all user types
export const MAX_SERVICES_ESTIMATE = 100;
export const DEFAULT_SB_FOR_CLUSTERS = {
    startDate: "2024-01-01",
    endDate: "2050-12-31",
    startTime: "00:00",
    endTime: "23:55",
    type: "AVAILABLE",
    weeksToRepeat: 1,
    weekDays: "0123456"
};
export const dayAbbreviations = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
export const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
export const weekOfMonth = ["1st", "2nd", "3rd", "4th", "last"];
export const MIN_SEARCH_TERM_LENGTH = 3;
export const CLIENT_LOCATION_ID = "customerLocation";
export const PAY_TYPE_CC = "CC";
export const PAY_TYPE_NEW_CC = "newCC";
export const PAY_TYPE_PACKAGE = "package";
export const PAY_TYPE_COLLECT_LATER = "collectLater";
export const PACKAGE_TYPE_DOLLAR = "DOLLAR";
export const PACKAGE_TYPE_PERCENT = "PERCENT";
export const PACKAGE_TYPES = [PACKAGE_TYPE_DOLLAR, PACKAGE_TYPE_PERCENT];
export const DEFAULT_STRIPE_CHARGE_CARD_STATE = {
    cardNumber: {
        brand: "unknown",
        complete: false,
        elementType: "cardNumber",
        empty: true,
        value: undefined
    },
    cardExpiry: {
        complete: false,
        elementType: "cardExpiry",
        empty: true,
        value: undefined
    },
    cardCvc: {
        complete: false,
        elementType: "cardCvc",
        empty: true,
        value: undefined
    }
};
export const bookingFlowLogo =
    "https://marketbox-public-pics.s3.us-east-1.amazonaws.com/bookingFlow-logo.jpeg";
export const bookingFlowHeadingOne =
    "https://marketbox-public-pics.s3.us-east-1.amazonaws.com/bookingFlow-headingone.jpeg";
export const bookingFlowHeadingTwo =
    "https://marketbox-public-pics.s3.us-east-1.amazonaws.com/bookingFlow-headingtwo.jpeg";
export const bookingFlowHeadingThree =
    "https://marketbox-public-pics.s3.us-east-1.amazonaws.com/bookingFlow-headingthree.jpeg";
export const timeMapping = {
    "12:00 AM": "24:00",
    "12:15 AM": "00:15",
    "12:30 AM": "00:30",
    "12:45 AM": "00:45",
    "1:00 AM": "01:00",
    "1:15 AM": "01:15",
    "1:30 AM": "01:30",
    "1:45 AM": "01:45",
    "2:00 AM": "02:00",
    "2:15 AM": "02:15",
    "2:30 AM": "02:30",
    "2:45 AM": "02:45",
    "3:00 AM": "03:00",
    "3:15 AM": "03:15",
    "3:30 AM": "03:30",
    "3:45 AM": "03:45",
    "4:00 AM": "04:00",
    "4:15 AM": "04:15",
    "4:30 AM": "04:30",
    "4:45 AM": "04:45",
    "5:00 AM": "05:00",
    "5:15 AM": "05:15",
    "5:30 AM": "05:30",
    "5:45 AM": "05:45",
    "6:00 AM": "06:00",
    "6:15 AM": "06:15",
    "6:30 AM": "06:30",
    "6:45 AM": "06:45",
    "7:00 AM": "07:00",
    "7:15 AM": "07:15",
    "7:30 AM": "07:30",
    "7:45 AM": "07:45",
    "8:00 AM": "08:00",
    "8:15 AM": "08:15",
    "8:30 AM": "08:30",
    "8:45 AM": "08:45",
    "9:00 AM": "09:00",
    "9:15 AM": "09:15",
    "9:30 AM": "09:30",
    "9:45 AM": "09:45",
    "10:00 AM": "10:00",
    "10:15 AM": "10:15",
    "10:30 AM": "10:30",
    "10:45 AM": "10:45",
    "11:00 AM": "11:00",
    "11:15 AM": "11:15",
    "11:30 AM": "11:30",
    "11:45 AM": "11:45",
    "12:00 PM": "12:00",
    "12:15 PM": "12:15",
    "12:30 PM": "12:30",
    "12:45 PM": "12:45",
    "1:00 PM": "13:00",
    "1:15 PM": "13:15",
    "1:30 PM": "13:30",
    "1:45 PM": "13:45",
    "2:00 PM": "14:00",
    "2:15 PM": "14:15",
    "2:30 PM": "14:30",
    "2:45 PM": "14:45",
    "3:00 PM": "15:00",
    "3:15 PM": "15:15",
    "3:30 PM": "15:30",
    "3:45 PM": "15:45",
    "4:00 PM": "16:00",
    "4:15 PM": "16:15",
    "4:30 PM": "16:30",
    "4:45 PM": "16:45",
    "5:00 PM": "17:00",
    "5:15 PM": "17:15",
    "5:30 PM": "17:30",
    "5:45 PM": "17:45",
    "6:00 PM": "18:00",
    "6:15 PM": "18:15",
    "6:30 PM": "18:30",
    "6:45 PM": "18:45",
    "7:00 PM": "19:00",
    "7:15 PM": "19:15",
    "7:30 PM": "19:30",
    "7:45 PM": "19:45",
    "8:00 PM": "20:00",
    "8:15 PM": "20:15",
    "8:30 PM": "20:30",
    "8:45 PM": "20:45",
    "9:00 PM": "21:00",
    "9:15 PM": "21:15",
    "9:30 PM": "21:30",
    "9:45 PM": "21:45",
    "10:00 PM": "22:00",
    "10:15 PM": "22:15",
    "10:30 PM": "22:30",
    "10:45 PM": "22:45",
    "11:00 PM": "23:00",
    "11:15 PM": "23:15",
    "11:30 PM": "23:30",
    "11:45 PM": "23:45"
};
export const MBX_ERRORS = { stripeError: "MBX_STRIPE_ERROR" };

export const GOOGLE_CAL_INTEGRATION_STATUS_AUTHED = "authed";
export const GOOGLE_CAL_INTEGRATION_STATUS_SYNCED = "synced";
export const GOOGLE_CAL_INTEGRATION_STATUS_SYNCING = "syncing";
export const GOOGLE_CAL_INTEGRATION_QUEUED_FOR_SYNCING = "queuedForSyncing";
export const GOOGLE_CAL_INTEGRATION_STATUS_SYNC_FAILED = "syncingFailed";
export const GOOGLE_CAL_INTEGRATION_STATUSES = [
    GOOGLE_CAL_INTEGRATION_STATUS_AUTHED,
    GOOGLE_CAL_INTEGRATION_STATUS_SYNCED,
    GOOGLE_CAL_INTEGRATION_STATUS_SYNCING,
    GOOGLE_CAL_INTEGRATION_QUEUED_FOR_SYNCING,
    GOOGLE_CAL_INTEGRATION_QUEUED_FOR_SYNCING,
    GOOGLE_CAL_INTEGRATION_STATUS_SYNC_FAILED
];
export const GOOGLE_CAL_INTEGRATION_ID = "googleCal";
export const INFO_WINDOW_NONE = "INFO_WINDOW_NONE";
export const INFO_WINDOW_TRAVELZONE = "INFO_WINDOW_TRAVELZONE";
export const INFO_WINDOW_BOOKING = "INFO_WINDOW_BOOKING";
export const INFO_WINDOW_WAITLIST = "INFO_WINDOW_WAITLIST";
export const DEFAULT_MAP_DATE_RANGE = {
    start: new Date(new Date()),
    end: endOfMonth(new Date().setDate(180))
};

export const DEFAULT_BOOKING_DETAILS = {
    schedules: [],
    isRepeating: false,
    selectedLocationId: null,
    bookingOnBehalf: null,
    currency: DEFAULT_CURRENCY,
    repeatingAppointmentList: [],
    selectedPackage: null,
    selectedPackageRemainingQuantity: null,
    isPkgCredit: false,
    payType: PAY_TYPE_CC,
    clientNotes: "",
    heldSlots: [],
    isBookingDateTimeOptimized: null,
    sessions: []
};
